export default {
  CREATE_ON_BOARDING_INVITE_FRIEND_REPOSITORY: Symbol.for('CREATE_ON_BOARDING_INVITE_FRIEND_REPOSITORY'),
  CREATE_ON_BOARDING_INVITE_FRIEND_COMMAND: Symbol.for('CREATE_ON_BOARDING_INVITE_FRIEND_COMMAND'),
};
